import React, {useState, useEffect, useRef, useMemo} from 'react';
import {useSelector} from 'react-redux';

import * as S from './UpdatePasswordUI.styles';

import * as C from '../Onboarding/Common.styles';
import OTPBlock from '../UI/OTP/otp';
import ButtonLoader from '../UI/Loader/Loader';
import {sendEvarData} from '@ibibo/analytics';
import IconSelector from '@ibibo/icon-selector';
import Eye from '../../components/Onboarding/UserPassword/EyeIcon';


import {
  mobileCount,
  emailCount,
} from '../../../store/selectors';
import {validations} from '../../../utils/validations';

const UpdatePasswordUI = ({submitDetails, resendOTP, apiError, sendOTP, isLoading, userMobile, mobileUser, setPassword, loginApiMessage}) => {

  // const dispatch = useDispatch();
  const mobile_count = useSelector(mobileCount);


  const [{user_name, password, confirm_pass}, setUserPass] = useState({
    // user_name: mobileUser,
    password: '',
    confirm_pass: ''
  });


  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const mobileOtpRef = useRef(null);



  const [{confirmErrors, errorCheck} ,  setconfirmErrors] = useState({
    confirmErrors: '',
    errorCheck: false
  });

  
  const errorCallback = () => {
  }


  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    if(mobileUser) {
      setUserPass({
        user_name: mobileUser,
        password,
        confirm_pass
      })
    }
  }, [mobileUser]);


  const minPwdLen = 8;

  const onChangeHandler = (field, value) => {
    const data = {
      password,
      confirm_pass
    };
    data[field] = value;
    setUserPass(data);
    if (field === 'password') {
      onKeyPress(data[field]);
    }
  }

  const fieldValidators = {
    // 'user_name': {'field': 'user_name', 'fieldName': 'User name', 'validators': ['required']},
    'password': {'field': 'password', 'fieldName': 'Password', 'validators': ['required', 'password']},
    'confirm_pass': {'field': 'confirm_pass', 'fieldName': 'Confirm Password', 'validators': ['required', 'sameFieldValue']},
    'mobile_otp': { 'field': 'mobile_otp', 'fieldName': 'Mobile OTP', 'validators': ['required', 'numeric', 'fixedLength']}
    // 'tncChecked': {'field': 'password', 'fieldName': 'terms and conditions', 'validators': ['mustRead']}
  };

  const validateField = (field, dataObj) => {
    const errorObj = {...errors};
    if (fieldValidators[field]) {
      errorObj[field] = '';
      const validators = fieldValidators[field].validators;
      for (let i = 0; i < validators.length; i++) {
        const validateFunction = validations[validators[i]];
        const validateDataObj = {
          value: dataObj[field],
          fieldName: fieldValidators[field].fieldName,
          length: minPwdLen
        };
        if (field === 'confirm_pass') {
          validateDataObj.valueToMatch = password;
          validateDataObj.fieldToMatch = 'password';
        }
        const resp = validateFunction(validateDataObj);
        if (resp && !errorObj[field]) {
          errorObj[field] = resp;
        }
      }
    }
    setError(errorObj);
  };

  const validateFields = (data) => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const validateDataObj = {
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            length: minPwdLen
          };
          if (key === 'confirm_pass') {
            validateDataObj.valueToMatch = password;
            validateDataObj.fieldToMatch = 'password';
          }
          const resp = validateFunction(validateDataObj);
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  }


  const setUserNamePass = (event: React.FormEvent) => {
    sendEvarData({
      prop54: "myPatner|signup|setPassword|getStarted"
    }, true)
    event.preventDefault();
      const data = {
        password,
        confirm_pass,
      };
      const hasError = validateFields(data);
      if (!hasError) {
        if(password === confirm_pass){
          data.mobile_otp = mobileOtpRef.current.value
          setPassword(data);
          setconfirmErrors({confirmErrors: '', errorCheck: false});
        }else{
          setconfirmErrors({confirmErrors: 'Passwords are not matching', errorCheck: true});
        }
      }
  };

  const onKeyPress = (val) => {
    validateField('password', {password: val});
  }

  const onBlur = (field, val) => {
    validateField(field, {confirm_pass: val});
  }


  let passwordBlock = (
    <OTPBlock
      ref={mobileOtpRef}
      label="Mobile otp"
      subLabel=""
      otpLength={6}
      type="motp"
      error={errors['mobile_otp']}
      resendOTP={resendOTP}
      autoFocus={true}
      resendVisible={true}
    />
  );

  return (
    <C.FormMainWrapper>
      <C.WelcomeHeadText>Update Password</C.WelcomeHeadText>
      <C.HeadSubText>Please enter the OTP sent to your registered mobile number and set the new password!</C.HeadSubText>
      <C.HeadSubTitleText>
        <C.HeadSubTitleTextSpan>
         {loginApiMessage}
        </C.HeadSubTitleTextSpan>
      </C.HeadSubTitleText>
      <S.MainWrapperLogin>
        <C.FormWrapper onSubmit={setUserNamePass}>
          <C.UserInfoForm>
            {passwordBlock}
            <C.InputWrapper>
              <C.CommonInputWrap>
                <C.CommonInput
                  type={!showPassword ? 'password' : 'text'}
                  placeholder="New Password"
                  name="password"
                  value={password}
                  onChange={event => {
                    onChangeHandler('password', event.target.value);
                  }}
                  hasError={errors['password'] ? true : false}
                ></C.CommonInput>
                <C.ErrorText>{errors['password']}</C.ErrorText>
                <S.EyeWrapper>
                  <Eye
                    showPassword={showPassword}
                    setShowPassword={() => setShowPassword(!showPassword)}
                  />
                </S.EyeWrapper>
                {(errors['password'] && (
                  <S.StrongFailInfo>
                    <S.WeakText>Weak</S.WeakText>
                  </S.StrongFailInfo>
                )) ||
                  null}
                {(!errors['password'] && password !== '' && (
                  <S.StrongPassInfo>
                    <S.StongText>Strong</S.StongText>
                  </S.StrongPassInfo>
                )) ||
                  null}
              </C.CommonInputWrap>
            </C.InputWrapper>

            <C.InputWrapper>
              <C.CommonInputWrap>
                <C.CommonInput
                  type="password"
                  placeholder="Confirm password"
                  name="confirmPass"
                  value={confirm_pass}
                  onChange={event => onChangeHandler('confirm_pass', event.target.value)}
                  onBlur={event => onBlur('confirm_pass', event.target.value)}
                  hasError={errorCheck ? true : false}
                ></C.CommonInput>
                {(!errors['confirm_pass'] && confirm_pass !== '' && confirm_pass === password && (
                  <S.TickIconWrapper>
                    <IconSelector iconKey="tickmarkwhite" props={{width: '1rem', height: '1rem'}} />
                  </S.TickIconWrapper>
                )) ||
                  null}
                <C.ErrorText>{errors['confirm_pass']}</C.ErrorText>
                {confirmErrors.length > 0 && <C.ErrorText>{confirmErrors}</C.ErrorText>}
              </C.CommonInputWrap>
            </C.InputWrapper>

            <S.StronInfoWrapper>
              <S.StrongHeadText>Set a strong password:</S.StrongHeadText>
              <S.StrongSubText>
                Minimum 8 characters, with a mix of letters, numbers & symbols @$!%#?&
              </S.StrongSubText>
            </S.StronInfoWrapper>
            <C.ApiErrorText>{apiErrorMsg}</C.ApiErrorText>
            <C.ButtonWrapper>
              <C.SignUpBtn type="submit">
                {isLoading ? <ButtonLoader loaderType="button"/> : 'Update Password'}
              </C.SignUpBtn>
            </C.ButtonWrapper>
          </C.UserInfoForm>
        </C.FormWrapper>
      </S.MainWrapperLogin>
    </C.FormMainWrapper>
  );
};

export default UpdatePasswordUI;
